import Product from '../models/Product.js';

export const RESULTS_PER_PAGE = 12;

const getHandleFromUrl = url => {
  const pathnameParts = url.pathname.split('/');
  return pathnameParts[pathnameParts.length - 1];
};

const serializeQueryParams = params => {
  return Object.entries(params)
    .map(([key, value]) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .join('&');
};

export const getResults = (data = {}) => {
  const { active: currency } = window.Shopify.currency;

  return fetch(
    `https://searchserverapi.com/getresults?${serializeQueryParams({
      api_key: window.settings.searchanise.apiKey,
      output: 'json',
      items: true,
      facets: true,
      pages: true,
      q: '',
      'union[price][min]': `price_${currency}`,
      startIndex: 0,
      maxResults: RESULTS_PER_PAGE,
      ResultsDescriptionStrings: 1,
      shopify_currency: currency,
      ...data,
    })}`
  ).then(response => response.json());
};

export const convertResultToProduct = result => {
  const variants = result.shopify_variants.map(variant => {
    const newVariant = {
      ...variant,
      compare_at_price: Number(variant.list_price) * 100,
      id: Number(variant.variant_id),
      price: Number(variant.price) * 100,
    };

    /**
     * Items that aren't on sale have a compare at price of 0,
     * so we need to delete it.
     */
    if (newVariant.compare_at_price === 0) {
      delete newVariant.compare_at_price;
    }

    return newVariant;
  });

  const images = result.shopify_images
    ? result.shopify_images.map(image => image.replace(/_large\./, '.'))
    : [];
  const domain = `https://${window.Shopify.domain}`;
  const handle = getHandleFromUrl(new URL(result.link, domain));

  return new Product({
    ...result,
    id: Number(result.product_id),
    tags: result.tags.split('[:ATTR:]'),
    handle,
    images,
    variants,
  });
};
